import { Inject, Injectable } from '@angular/core';
import { POINTS_NUMBER_DIGITS_INFO } from '@rd/core/tokens/rd-lib.token';
import { RoundMode } from '@rd/types/round-mode.type';
import { NumberService } from '../number/number.service';

@Injectable({
  providedIn: 'root',
})
export class PointsNumberService {
  constructor(
    @Inject(POINTS_NUMBER_DIGITS_INFO) private digitsInfo: string,
    private numberService: NumberService,
  ) {}

  roundNumber(
    value: number,
    digitsInfo: string = this.digitsInfo,
    roundDigits: number = 0,
    roundMode: RoundMode = RoundMode.DOWN,
  ): string {
    const digitsToRound = Math.pow(10, roundDigits);
    let roundedValue = value;

    switch (roundMode) {
      case RoundMode.DOWN:
        roundedValue = Math.floor(roundedValue * digitsToRound) / digitsToRound;
        break;
      case RoundMode.UP:
        roundedValue = Math.ceil(roundedValue * digitsToRound) / digitsToRound;
        break;
      case RoundMode.NONE:
      default:
        break;
    }

    return this.numberService.formatNumber(roundedValue, digitsInfo);
  }
}
